<script>
import SimpleImagePreview from "@components/Business/ImageEditor/components/SimpleImagePreview.vue";
import {mapState} from "vuex";

export default {
  name: "ImageServerRenderer" ,
  components: {SimpleImagePreview},
  data(){
    return {
      imageName:null,
      imageUrl:null,
      recipientQueryString:null
    }
  },
  computed: {
    ...mapState('imageEditor', [
      'imagePreview',
      'overlaySettings',
      'recipientName'
    ]),
  },
  mounted(){
    const id = this.$route.params.id;
    const businessId = this.$route.params.business_id;
    this.recipientQueryString = this.$route.query?.recipient_name;
    this.$store
        .dispatch('imageEditor/getImageRendering',{ id:id, businessId:businessId })
        .then((data) => {
          this.imageName = data.name;
          this.imageUrl = data.url;
        }).catch((err) => {
      if (err) {
        console.log(err);
      }
    })
  }
}
</script>

<template>
  <simple-image-preview
      style="width:600px; height:600px;"
      :image-url="imageUrl"
      :overlay-settings="overlaySettings"
      :recipient-name="recipientQueryString"
      :hide-handles="true"
  />
</template>

<style scoped lang="scss">

</style>
